import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const API = `${process.env.REACT_APP_API_BASE_URL}/property-finder/sessions`;

export const getSessions = async () => {
  const response = await axios.get(`${API}`);

  return response?.data;
};

export const getMarketInsights = async (sessionId, property) => {
  const response = await axios.post(`${API}/${sessionId}/market-insights`, { property });

  return response?.data;
};

export const copyPropertyTitle = async (sessionId, propertyTitle) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/property-finder/copy-property-title`,
    {
      sessionId,
      propertyTitle
    }
  );

  return response?.data;
};

export const useSessions = () =>
  useQuery({
    queryKey: ['propertyFinderSessions'],
    queryFn: async () => {
      return await getSessions();
    }
  });
